import { EnMetricDistrict } from '@shared/dto';

/**
 * Head-to-toe rank so a list of districts reads the way a clinician reads a
 * body. A `Record` (not an array) so a new `EnMetricDistrict` fails the build
 * instead of sorting with BODY in the ROM dropdown (`rank.get(...) ?? 0`) or
 * vanishing from the screening chart, which only iterates the derived order.
 */
const METRIC_DISTRICT_RANK: Record<EnMetricDistrict, number> = {
  [EnMetricDistrict.BODY]: 0,
  [EnMetricDistrict.TRUNK]: 1,
  [EnMetricDistrict.WAIST]: 2,
  [EnMetricDistrict.SHOULDERWIDTH]: 3,
  [EnMetricDistrict.UPPERARM]: 4,
  [EnMetricDistrict.LOWERARM]: 5,
  [EnMetricDistrict.UPPERLEG]: 6,
  [EnMetricDistrict.LOWERLEG]: 7,
  [EnMetricDistrict.ANKLE]: 8,
};

export const METRIC_DISTRICT_ORDER: EnMetricDistrict[] = (
  Object.keys(METRIC_DISTRICT_RANK) as EnMetricDistrict[]
).sort((a, b) => METRIC_DISTRICT_RANK[a] - METRIC_DISTRICT_RANK[b]);

/**
 * A district names the body segment, with the Italian anatomical terms of
 * "Regioni del corpo umano": `UPPER_ARM` is the braccio, `LOWER_ARM` the
 * avambraccio, `UPPER_LEG` the coscia, `LOWER_LEG` the gamba. One map for the
 * whole app — a goal set here is plotted by the clinical diary, and the two
 * screens naming the same enum value differently is what a clinician reads as
 * two different body parts.
 */
export const METRIC_DISTRICT_LABELS: Record<EnMetricDistrict, string> = {
  [EnMetricDistrict.BODY]: $localize`Corpo`,
  [EnMetricDistrict.TRUNK]: $localize`Tronco`,
  [EnMetricDistrict.WAIST]: $localize`Bacino`,
  [EnMetricDistrict.SHOULDERWIDTH]: $localize`Ampiezza spalle`,
  [EnMetricDistrict.UPPERARM]: $localize`Braccio`,
  [EnMetricDistrict.LOWERARM]: $localize`Avambraccio`,
  [EnMetricDistrict.UPPERLEG]: $localize`Coscia`,
  [EnMetricDistrict.LOWERLEG]: $localize`Gamba (parte inferiore)`,
  [EnMetricDistrict.ANKLE]: $localize`Caviglia`,
};
